export const manualUrlList: {
	[key: string]: { [key: string]: { title: string; link: string } }
} = {
	KDM6: {
		en: {
			title: 'English',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem6/kedem+6+User+Manual+(English).pdf',
		},
		ko: {
			title: 'Korean',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem6/kedem+6+User+Manual+(Korean).pdf',
		},
		de: {
			title: 'German',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem6/kedem+6+User+Manual+(German).pdf',
		},
		es: {
			title: 'Spanish',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem6/kedem+6+User+Manual+(Spanish).pdf',
		},
		ja: {
			title: 'Japanese',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem6/kedem+6+User+Manual+(Japanese).pdf',
		},
	},
	KDM4: {
		en: {
			title: 'English',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem4/kedem+4+User+Manual+(English).pdf',
		},
		ko: {
			title: 'Korean',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem4/kedem+4+User+Manual+(Korean).pdf',
		},
		de: {
			title: 'German',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem4/kedem+4+User+Manual+(German).pdf',
		},
		es: {
			title: 'Spanish',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem4/kedem+4+User+Manual+(Spanish).pdf',
		},
		ja: {
			title: 'Japanese',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem4/kedem+4+User+Manual+(Japanese).pdf',
		},
	},
}
